export default __webpack_public_path__ + "static/media/icon-table-oil.feb61f91.svg";